export enum ReduxActionType {
    SetCounter,
    IncrementCounter,
}
